import React, { useState } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setSelectedTask } from 'actions/tools/OrdersSearchActions';
import { extractSelectedTicketFromState } from 'extractFromState';
import { shopifySendAccountCreationEmail } from 'actions/tools/ShopifyActions';
import { getSelectedOrder } from 'selectors/tools';
import { oneBtnPopupCreator, twoBtnPopupCreator } from '../../popups/ConfirmPopup/helper';
import * as Styled from 'components/tools/common/CommonStyledComponents';
import { Button, FullColoredButton } from 'components/common/buttonsComponents';
import Loading from 'components/LoadingComponent/LoadingComponent';
import * as sensitiveData from 'constants/sensitiveDataTypes';
import ProtectedData from 'components/common/ProtectedData/ProtectedData';

const ShopifyResendAccountCreationEmail = (props) => {
  const [isRequestSending, setRequestSending] = useState(false);

  const customerId = get(props, 'selectedOrder.customer.id');
  const customerEmail = get(props, 'selectedOrder.customer.email');

  const handleFailedRequest = () => {
    oneBtnPopupCreator({
      content: {
        main: 'Send email failed',
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  const handleSuccessRequest = () => {
    props.setSelectedTask(null);
    oneBtnPopupCreator({
      content: {
        main: `Email sent successfully`,
        iconPath: '/images/checkmark-green.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  const sendEmail = async () => {
    setRequestSending(true);
    const conversationId = get(props, 'selectedTicket.ticketId');
    try {
      await props.shopifySendAccountCreationEmail({
        customerId: String(customerId),
        conversationId,
        addNotes: true,
      });
      handleSuccessRequest();
    } catch (e) {
      handleFailedRequest();
    } finally {
      setRequestSending(false);
    }
  };

  const handleRefundBtnClick = () => {
    twoBtnPopupCreator({
      content: {
        main: 'Are you sure you want to send an email?',
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'SEND',
      },
      onConfirm: sendEmail,
    });
  };

  if (!customerId || !customerEmail) {
    return (
      <Styled.OrderTaskWrapper>
        <Styled.OrderTaskTitle>Resend Account Creation Email</Styled.OrderTaskTitle>
        <Styled.OrderTaskDescription>Customer is not available.</Styled.OrderTaskDescription>
        <Styled.OrderTaskControls>
          <Button onClick={() => props.setSelectedTask(null)}>BACK</Button>
        </Styled.OrderTaskControls>
      </Styled.OrderTaskWrapper>
    );
  }

  if (isRequestSending) {
    return <Loading label="Sending email..." />;
  }

  return (
    <Styled.OrderTaskWrapper>
      <Styled.OrderTaskTitle>Resend Account Creation Email</Styled.OrderTaskTitle>
      <Styled.OrderTaskDescription>You can send an account invite to a customer.</Styled.OrderTaskDescription>
      <div>
        The email will be sent to -{' '}
        <ProtectedData
          data={customerEmail}
          dataType={sensitiveData.email}
          component={'ShopifyResendAccountCreationEmail'}
        />
      </div>
      <Styled.OrderTaskControls>
        <Button onClick={() => props.setSelectedTask(null)}>BACK</Button>
        <FullColoredButton active={true} onClick={handleRefundBtnClick}>
          SEND
        </FullColoredButton>
      </Styled.OrderTaskControls>
    </Styled.OrderTaskWrapper>
  );
};

ShopifyResendAccountCreationEmail.propTypes = {
  selectedOrder: PropTypes.object.isRequired,
  selectedTicket: PropTypes.object,
  setSelectedTask: PropTypes.func,
};

ShopifyResendAccountCreationEmail.defaultProps = {
  setSelectedTask: () => {},
};

const mapStateToProps = (state) => ({
  selectedOrder: getSelectedOrder(state),
  selectedTicket: extractSelectedTicketFromState(state),
});

export default connect(mapStateToProps, {
  setSelectedTask,
  shopifySendAccountCreationEmail,
})(ShopifyResendAccountCreationEmail);
